import React, {useEffect, useState} from 'react';

import {EEventSource} from 'coreClasses/events/IEvents';
import Skeleton from 'coreComponents/Skeleton';
import withSSRPage from 'coreComponents/withSSRPage';
import {useCustomerMgr, useLocalesMgr, useOrdersMgr, usePageInit, useUI} from 'coreHooks';
import {useRouterHistory as useHistory} from 'coreUtils/adapters/router';

import CustomerCareWidget from 'brandComponents/CustomerCareWidget';
import Grid from 'brandComponents/Grid';
import ReturnAuthorizationCreateForm from 'brandComponents/ReturnAuthorizationCreateForm';
import ReturnAuthorizationLoginForm from 'brandComponents/ReturnAuthorizationLoginForm';
import ReturnInstructions from 'brandComponents/ReturnInstructions';
import {useHandlePageEvents} from 'brandHooks/useHandlePageEvents';

import messages from './messages';

import styles from './ReturnOrder.module.scss';

const ReturnOrderContent = () => {
	usePageInit({
		route: 'ReturnOrder',
		seo: {
			metadata: [{title: messages.returnOrderTitle, description: 'Return Order'}],
			pageUrls: '/return',
		},
	});

	const localesMgr = useLocalesMgr();
	const currentLocale = localesMgr.getCurrentLocale();
	const CustomerMgr = useCustomerMgr();
	const customer = CustomerMgr.getCurrentCustomer();
	const ordersMgr = useOrdersMgr();
	const selectedReturnOrder = useUI('selectedReturnOrder' as any);
	const selectedReturnOrderZip = useUI('selectedReturnOrderZip' as any);
	const history = useHistory();
	const [returnOrder, setReturnOrder] = useState(null);
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		// TODO: Review logic
		if (selectedReturnOrder && selectedReturnOrderZip) {
			ordersMgr.getOrderByZipCode(selectedReturnOrder, selectedReturnOrderZip).then((order) => {
				setReturnOrder(order);
				setLoaded(true);
			}).catch(() => {
				setLoaded(true);
			});
		} else if (selectedReturnOrder) {
			ordersMgr.getCustomerOrder(selectedReturnOrder).then((order) => {
				setReturnOrder(order);
				setLoaded(true);
			});
		} else {
			setLoaded(true);
		}
	}, [selectedReturnOrder, selectedReturnOrderZip]);

	useEffect(() => {
		localesMgr.updateUrl();
	}, [currentLocale.getCode(), localesMgr.isCookiesProcessed()]);

	useHandlePageEvents({pageType: EEventSource.RETURN_ORDER}, [currentLocale.getCode()]);

	useEffect(() => {
		if (customer.isRegistered && !selectedReturnOrder) {
			history.replace(localesMgr.updateLinkWithLocale('/myaccount'));
		}
	}, [customer.isRegistered]);

	const classNames = {
		wrapper: styles['return-order__wrapper'],
		widget: styles['return-order__widget'],
		form: styles['return-order__form'],
	};

	return (
		<>
			{
				!loaded ? (
					<Skeleton />
				) : (
					<>
						<Grid fluid classNames={classNames.wrapper}>
							<Grid.Row classNames="return-order__wrapper__row">
								<Grid.Column xs={12} lg={3} classNames={classNames.widget}>
									<CustomerCareWidget isReversedWidget />
								</Grid.Column>
								<Grid.Column xs={12} lg={9} classNames={classNames.form}>
									{returnOrder ? (
										<ReturnAuthorizationCreateForm
											returnOrder={returnOrder}
											handleSuccess={() => history.replace('/')}
											countryCode={currentLocale.getCountryCode()}
										/>
									) : (
										<ReturnAuthorizationLoginForm onReturnOrderSelected={setReturnOrder} />
									)}
								</Grid.Column>
							</Grid.Row>
						</Grid>
						<ReturnInstructions isZeroStep={true} />
					</>
				)
			}
		</>
	);
};

export default withSSRPage(ReturnOrderContent, 'return-order');
